@if (alertas.length) {
  <div #barra class="alert-banner-stack">
    @for (alerta of alertas; track alerta.id) {
      <div class="alert-banner" [ngClass]="alerta.tipoAlerta" role="alert" aria-live="polite">
        <mat-icon class="material-symbols-outlined alert-banner__icon">{{ alerta.icone }}</mat-icon>

        <span class="alert-banner__text">@if (alerta.prefixo) {<strong>{{ alerta.prefixo }}</strong> }{{ alerta.mensagem }} <a class="alert-banner__link" (click)="onClick(alerta)">{{ alerta.textoLink }}</a></span>

        @if (alerta.podeFechar) {
          <button
            class="alert-banner__close"
            type="button"
            (click)="fechar(alerta, $event)"
            aria-label="Fechar aviso">
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>
    }
  </div>
}
